import React, { useEffect, useState } from "react";
import "../css/OfferListScreens.css";
import BottomNav from "../components/BottomNav";
import SearchBarOfferList from "../components/SearchBarOfferList";
import RadiusSelector from "../components/RadiusSelector";
import { useLocation } from "react-router-dom";
import {
	fetchFilteredOffers,
	fetchHomeOffers,
} from "../apiIntegration/getOfferDataFromFirebase";
import Categories from "../components/Categories";
import OfferTemplateRenderer from "../components/offerDetails/offerTemplates/OfferTemplateRenderer";
import { BlinkBlur } from "react-loading-indicators";
import { useQuery } from "@tanstack/react-query";

export default function OfferListScreens() {
	const locationState = useLocation();
	const [tab, setTab] = useState("offers");
	const [userLocation, setUserLocation] = useState(null);
	const [locationLoading, setLocationLoading] = useState(true);
	const [distanceKm, setDistanceKm] = useState(
		locationState.state?.distanceKm || 5,
	);
	const [selectedCategory, setSelectedCategory] = useState(
		locationState?.state?.category || "all",
	);
	const [selectedSubCategory, setSelectedSubCategory] = useState(
		locationState?.state?.subCategory || "all",
	);

	/* ======================================================
	   GET LOCATION
	====================================================== */
	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});

		navigator.geolocation.getCurrentPosition(
			(position) => {
				setUserLocation({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				});
				setLocationLoading(false);
			},
			(error) => {
				console.log(error);
				setLocationLoading(false);
			},
			{
				enableHighAccuracy: true,
			},
		);
	}, []);

	/* ======================================================
	   FETCH CATEGORIES (CACHED)
	====================================================== */
	const { data: categoryResponse } = useQuery({
		queryKey: [
			"offerCategories",
			userLocation?.lat?.toFixed(2),
			userLocation?.lng?.toFixed(2),
		],
		queryFn: () => fetchHomeOffers(userLocation, 30),
		enabled: !!userLocation,
		staleTime: 1000 * 60 * 10,
		cacheTime: 1000 * 60 * 30,
	});
	const categories = categoryResponse?.categories || [];

	/* ======================================================
	   FETCH OFFERS (CACHED)
	====================================================== */
	const { data: offers = [], isLoading: loading } = useQuery({
		queryKey: [
			"offerList",
			selectedCategory,
			selectedSubCategory,
			distanceKm,
			userLocation?.lat?.toFixed(2),
			userLocation?.lng?.toFixed(2),
		],

		queryFn: () =>
			fetchFilteredOffers({
				category: selectedCategory,
				subCategory: selectedSubCategory,
				userLocation,
				distanceKm,
			}),

		enabled: !!userLocation,
		staleTime: 1000 * 60 * 10,
		cacheTime: 1000 * 60 * 30,
		keepPreviousData: true,
	});

	const isPageLoading = locationLoading || loading;

	return (
		<div className="app">
			{/* <SearchBarOfferList /> */}

			<Categories
				categories={categories}
				selectedCategory={selectedCategory}
				setSelectedCategory={setSelectedCategory}
				selectedSubCategory={selectedSubCategory}
				setSelectedSubCategory={setSelectedSubCategory}
			/>

			<RadiusSelector radius={distanceKm} setRadius={setDistanceKm} />

			{/* ======================================================
			   OFFERS
			====================================================== */}
			<div className="px-3 mt-3">
				{isPageLoading ? (
					<div className="mt-5 nearBuSection">
						<BlinkBlur
							color="#494949"
							size="medium"
							text="Loading..."
							textColor="#ffffff"
						/>
					</div>
				) : !offers?.length ? (
					<p className="nearBuSection">No offers found</p>
				) : (
					offers.map((offer) => (
						<div key={offer.offerId} className="mb-4">
							<OfferTemplateRenderer
								data={offer}
								type={offer.offerTemplate || "dark"}
								previewUrl={offer.image}
							/>
						</div>
					))
				)}
			</div>

			<BottomNav active={tab} setActive={setTab} />
		</div>
	);
}
